import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable, filter, withLatestFrom } from 'rxjs';
import type { TreeEntity } from '../../../core/models/entity.model';
import { selectEntityTypes } from '../../../core/store/entity-types/entity-types.selectors';
import { EntityTypeKey } from 'src/app/shared/constants/entity-type-keys';
import { PropertyType } from 'src/app/core/models/property-type.model';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MeasurementUnit } from 'src/app/core/models/measurement-unit.model';
import { selectMeasurementUnits } from 'src/app/core/store/measurement-units/measurement-units.selector';
import { selectUserLanguageCode } from 'src/app/user-account/store/user-settings/user-settings.selectors';
import { Property } from 'src/app/core/models/property.model';

interface PropertyItem {
  propertyType: PropertyType;
  property: Property;
  measurementUnit: MeasurementUnit;
  formControl: FormControl;
}

@Component({
  selector: 'app-hood-data-form',
  templateUrl: './hood-data-form.component.html',
  styleUrls: ['./hood-data-form.component.scss'],
  standalone: false
})
export class HoodDataFormComponent implements OnInit, OnChanges {
  @Input() projectEntity: TreeEntity;

  localeCode$: Observable<string>;
  selectedId = '';

  protected propertyItems$: Observable<PropertyItem[]>;

  hoodEntity: TreeEntity;

  constructor(private store: Store, private route: ActivatedRoute) {
    this.selectedId = this.route.snapshot.queryParamMap.get('selectedId');

    this.localeCode$ = this.store.select(selectUserLanguageCode);

    this.propertyItems$ = this.store.select(selectMeasurementUnits).pipe(
      withLatestFrom(this.store.select(selectEntityTypes)),
      map(([measurementUnits, entitiyTypes]) => {
        const hooodTypes = entitiyTypes[EntityTypeKey.GastroFlowHood];

        const hoodDataProperties: PropertyType[] = [];

        hooodTypes.Groups.forEach(group =>
          group.Properties.filter(p => p.MetaData['UIGroup'] === 'HoodLineHoodDataGroup').forEach(p => {
            hoodDataProperties.push(p);
          })
        );

        return hoodDataProperties.map(p => {
          return {
            propertyType: p,
            property: this.getProperty(p),
            measurementUnit: this.getMeasurementUnit(p, measurementUnits),
            formControl: this.getFormControl(p)
          } as PropertyItem;
        });
      }),
      filter(value => !!value)
    );
  }

  ngOnInit(): void {
    this.setHoodEntity();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectEntity']) {
      this.setHoodEntity();
    }
  }

  getProperty(propertyType: PropertyType): Property {
    return this.hoodEntity && this.hoodEntity.Properties[propertyType.Key];
  }

  getMeasurementUnit(propertyType: PropertyType, measurementUnits: Record<string, MeasurementUnit>): MeasurementUnit {
    return measurementUnits[this.getProperty(propertyType).MeasurementUnit.Key];
  }

  getFormControl(propertyType: PropertyType) {
    const formControl = new FormControl();

    formControl.setValue(this.hoodEntity && this.hoodEntity.Properties[propertyType.Key]?.Value);

    return formControl;
  }

  setHoodEntity() {
    if (this.selectedId && this.projectEntity) {
      this.hoodEntity = this.projectEntity.Children.find(f => f.EntityTypeKey === EntityTypeKey.GastroFlowHood && f.Id === this.selectedId);
    } else {
      this.hoodEntity = null;
    }
  }
}
